/* eslint-disable */
export default {
  logged: 'Kirjattu lokiin',
  unlogged: 'Ei lokissa',
  faxNotSupported: 'Faksien kirjaamista lokiin ei tueta.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
